import { Text, Flex, Button, Center, AspectRatio, Box, useBreakpointValue, Container } from '@chakra-ui/react';
import NextImage from 'next/image';
import NextLink from 'next/link';
import { FC } from 'react';

import PlayIcon from '@/assets/icons/ic-play.svg';
import PresentationHeadingImage from '@/assets/images/publishers/header-bg.png';

export const PublishersHeader: FC = () => {
  return (
    <Center mt={-16} bgColor="black" position="relative">
      <AspectRatio objectFit="cover" minH={{ base: '740px', sm: '600px', lg: '720px' }} w="full" ratio={1905 / 530}>
        <NextImage
          objectPosition="center"
          quality={90}
          layout="fill"
          priority={true}
          src={PresentationHeadingImage}
          alt="Hero cover"
        />
      </AspectRatio>
      <Container
        display="flex"
        position="absolute"
        justifyContent="center"
        alignItems="center"
        h={{ base: '530px', sm: '485px', md: '630px', lg: '630px' }}
        px={{ base: 5, md: 10, lg: 5 }}
      >
        <Flex
          mt={10}
          maxW="996px"
          w="full"
          borderRadius={16}
          bg="white"
          textAlign="center"
          flexDirection="column"
          alignSelf="center"
          justifySelf="center"
          justifyContent="center"
          alignItems="center"
          padding={{ base: 6, md: 8, lg: 10 }}
          pb={6}
        >
          <Flex
            p={{ base: 4, md: 6 }}
            w="full"
            borderRadius={16}
            background="linear-gradient(90deg, #E179F1 0%, #BD8AF5 26.56%, #70B5EF 50%, #5BC5DF 74.48%, #52A3B0 98.96%)"
            flexDirection="column"
            alignItems="center"
          >
            <Text
              fontFamily="heading"
              maxW={{ base: '305px', sm: '402px', lg: '726px' }}
              color="white"
              fontSize={{ base: '2xl', sm: '3xl', lg: '5xl' }}
              textAlign="center"
              fontWeight="bold"
            >
              Don&apos;t Let Travel Restrictions Silence Brilliant Minds
            </Text>
          </Flex>
          <Flex flexDirection="column" maxW="793px">
            <Text my={{ base: 2, md: 6 }} fontSize={{ base: 'lg', lg: 'xl' }} fontWeight="500">
              Record, stream, and share your scientific conference with global researchers who can&apos;t attend in
              person. Keep your science connected even when facing travel or other challenges.
            </Text>
            <Text fontSize="lg">
              Underline Science provides a simple, affordable solution to record your proceedings, engage a worldwide
              audience, and create a permanent, citable digital archive for your society. Guarantee your global reach
              and preserve your legacy, affordably. Find out more today.
            </Text>
          </Flex>

          <NextLink href="/contact-us/conferences">
            <Button type="button" size={{ base: 'sm', lg: 'lg' }} leftIcon={<PlayIcon width="24px" />} mt={5}>
              Book a free consultation
            </Button>
          </NextLink>
        </Flex>
      </Container>
    </Center>
  );
};
